<template>
  <div class="c-appbar">
    <div class="appbar-links">
      <n-link class="appbar-link" :to="{name:'main'}">
        <img class="icon" :src="routeName === 'main' ? imgIndexActive : imgIndex" alt="">
        <p :class="{'active': routeName === 'main'}">Главная</p>
      </n-link>
      <n-link class="appbar-link" :to="{name:'shop'}">
        <img class="icon" :src="routeName === 'shop' ? imgShopActive : imgShop" alt="">
        <p :class="{'active': routeName === 'shop'}">Магазин</p>
      </n-link>
      <n-link class="appbar-link" :to="{name:'news'}">
        <img class="icon" :src="routeName === 'news' ? imgNewsActive : imgNews" alt="">
        <p :class="{'active': routeName === 'news'}">Новости</p>
      </n-link>
      <n-link class="appbar-link" :to="{name:'hrRequests'}">
        <img class="icon requests-icon" :class="{'active': isHrRequestsRoute}" :src="imgRequests" alt="">
        <p :class="{'active': isHrRequestsRoute}">Заявки</p>
      </n-link>
      <n-link class="appbar-link" :to="{name: 'profile'}">
        <img class="icon" :src="routeName === 'profile' ? imgProfileActive : imgProfile" alt="">
        <p :class="{'active': routeName === 'profile'}">Профиль</p>
      </n-link>
    </div>
  </div>
</template>

<script>
import imgIndex from 'assets/appbar/index.svg'
import imgShop from 'assets/appbar/shop.svg'
import imgNews from 'assets/appbar/news.svg'
import imgProfile from 'assets/appbar/profile.svg'
import imgIndexActive from 'assets/appbar/indexActive.svg'
import imgShopActive from 'assets/appbar/shopActive.svg'
import imgNewsActive from 'assets/appbar/newsActive.svg'
import imgProfileActive from 'assets/appbar/profileActive.svg'
import imgRequests from 'assets/profile/nav-icons/icon-wanted-time.svg'

export default {
  name: 'CAppbar',
  data() {
    return {
      imgIndex,
      imgShop,
      imgNews,
      imgProfile,
      imgIndexActive,
      imgShopActive,
      imgNewsActive,
      imgProfileActive,
      imgRequests,
    }
  },
  computed: {
    routeName() {
      return this.$route.name
    },
    isHrRequestsRoute() {
      return [ 'hrRequests', 'hrRequestSelect', 'hrRequestForm', ].includes(this.routeName)
    },
  },
  watch: {},
  created() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.c-appbar {
  position: fixed;
  z-index: 100;
  left: 0;
  right: 0;
  border-bottom: 0;
  bottom: 0;
  height: 80px;
  background-color: #ffffff;
  padding: 5px 15px 0;
  box-shadow: 0px -4px 8px rgba(33, 37, 66, 0.04);

  .appbar-links {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;

    .appbar-link {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 55px;
      min-width: 0;
      .icon {
        width: 28px;
        height: 28px;
        object-fit: contain;
      }
      .requests-icon.active {
        filter: brightness(0) saturate(100%) invert(86%) sepia(85%) saturate(1188%) hue-rotate(348deg) brightness(100%);
      }

      p {
        line-height: 1;
        font-size: .9em;
        color: var(--secondary);
        &.active {
          color: var(--primary);
        }
      }
    }
  }
}
</style>
